module.exports = __webpack_public_path__ + "media/en_us_s5_Susan.b696313f.oga";